import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=47208ec4&"
import script from "./Headline.vue?vue&type=script&lang=js&"
export * from "./Headline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports